export const isPrimaryFlow = () => {
  const postbookingUrls = ['postbooking.products.action', 'rf.order-details.extra-products.action'];
  return !postbookingUrls.some(str => window.location.pathname.includes(window.spa_variables.routes[str]));
};
//# sourceMappingURL=primaryFlow.js.map